import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const internshipSchema = itemSchema.extend({
  company: urlSchema,
  position: z.string(),
  location: z.string(),
  date: z.string(),
  summary: z.string(),
  url:  z.any(),
  companyDescription: z.string().max(90).optional().default(""),
});

// Type
export type Internship = z.infer<typeof internshipSchema>;

// Defaults
export const defaultInternship: Internship = {
  ...defaultItem,
  company: defaultUrl,
  position: "",
  location: "",
  date: "",
  summary: "",
  url: defaultUrl,
  companyDescription: "",
};
